import React, { useState } from 'react'
import { play } from '../../assets'
import { Boy } from '../../assets'
import VideoModal from '../Generic/Modal/videoModal'

const ProfilePostCard = ({fileType, path}) => {
  const [isVidModalOpen, setisVidModalOpen] = useState(false);
 
  const openVidModal = () => {
    setisVidModalOpen(true);
  };
  const closeVidModal = () => {
    setisVidModalOpen(false);
  };
  return (
    <>
        <div onClick={openVidModal} className=' min-w-[100px] w-full h-full z-10  min-h-[100px] overflow-hidden flex justify-center relative align-middle sm:w-[180px] sm:h-[180px] md:w-[200px] md:h-[200px] lg:w-[265px] lg:h-[265px]'>
            <div className='absolute'><img className='w-full ' src={Boy} alt="" /></div>
            { fileType==='video' &&
              <div className='absolute top-[calc(50%-16px)]'>{play.play}</div>
            }
            <div className='absolute top-[calc(50%+20px)] flex justify-center items-center rounded-[2px] text-[8px] bg-[rgba(57,_96,_149,_0.31)] w-[50px] h-[13px] backdrop-blur-[2px] text-white'>Kimyo</div>
        </div>
            <VideoModal children={fileType} fileType={fileType} path={'/toplam'}  onClose={closeVidModal} isOpen={isVidModalOpen}/>
    </>
  )
}

export default ProfilePostCard